import { render } from "./InputsFormatter.vue?vue&type=template&id=40ae12c6&scoped=true"
import script from "./InputsFormatter.vue?vue&type=script&lang=js"
export * from "./InputsFormatter.vue?vue&type=script&lang=js"

import "./InputsFormatter.vue?vue&type=style&index=0&id=40ae12c6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ae12c6"]])

export default __exports__